<template>
  <div>
    <el-form :label-width="labelWidth" label-suffix="：">
      <el-form-item label="公告内容" :required="required">
        <el-button type="primary" @click="open">
          选择模板
        </el-button>
      </el-form-item>
    </el-form>

    <!---选择模板的弹窗---->
    <jczh-drawer
      :visible.sync="drawerVisible"
      title="选择模板"
      confirm-button-text="确定"
      size="700px"
      :el-attrs="{
        destroyOnClose: true
      }"
      @close="handleDrawerClose"
      @confirm="handleConfirm"
    >
      <template slot="content">
        <el-form :form="filterForm" inline label-suffix="：" class="m-t-10">
          <el-form-item label="模板名称" prop="templateName">
            <el-input
              v-model="filterForm.templateName"
              placeholder="请输入"
              clearable
            />
          </el-form-item>
          <el-form-item label="公告类型" prop="noticeType">
            <el-select v-model="filterForm.noticeType" clearable>
              <el-option value="" label="全部" />
              <el-option
                v-for="item in templateNoticeTypeDict.array"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button @click="search">查询</el-button>
          </el-form-item>
        </el-form>
        <el-tabs v-model="activeName" stretch @tab-click="handleTabClick">
          <el-tab-pane
            v-for="item in tabList"
            :key="item.name"
            :name="item.name"
            :label="item.label"
          >
            <el-table
              border
              :data="tabObj[activeName].list"
              size="medium"
              highlight-current-row
              header-row-class-name="table-header"
              @row-click="select"
            >
              <el-table-column
                label="序号"
                prop="index"
                align="center"
                type="index"
                min-width="60"
              />
              <el-table-column
                label="模板名称"
                prop="templateName"
                align="center"
                show-overflow-tooltip
                min-width="200"
              />
              <el-table-column
                label="模板类型"
                prop="templateTypeValue"
                align="center"
                show-overflow-tooltip
                min-width="200"
              />
              <el-table-column
                v-if="activeName === 'company'"
                label="创建人"
                prop="createUserName"
                align="center"
                show-overflow-tooltip
                min-width="100"
              />
            </el-table>
            <pagination
              v-show="tabObj[activeName].total > 0"
              ref="pagination"
              :total="tabObj[activeName].total"
              :page.sync="tabObj[activeName].page"
              :limit.sync="tabObj[activeName].size"
              @pagination="getList"
            />
          </el-tab-pane>
        </el-tabs>

        <template slot="footer">
          <div style="width: 100%">
            <el-button
              style="width: 60px"
              @click="handleDrawerClose"
            >取消</el-button>
            <el-button
              style="width: 60px"
              type="primary"
              @click="handleConfirm"
            >确定</el-button>
          </div>
        </template>
      </template>
    </jczh-drawer>
  </div>
</template>
<script>
import Pagination from '@/components/common/Pagination'

import { getTemplateNoticeListApi } from '@/api/template'

import { templateTypeDict, templateNoticeTypeDict } from '@/dictionary/template'
export default {
  components: { Pagination },

  props: {
    purchaseType: {
      type: [String, Number],
      default: ''
    },
    noticeType: {
      type: [String, Number],
      default: ''
    },
    required: {
      type: [Boolean],
      default: true
    },
    labelWidth: {
      type: String,
      default: '120px'
    },
    // 是否企业模板在前面
    isCompanyFirst: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      templateNoticeTypeDict,

      drawerVisible: false,
      activeName: 'platform',

      selectRow: {},

      filterForm: {
        templateName: '',
        noticeType: ''
      },

      platformList: [],
      platformPage: {
        page: 1,
        size: 10,
        total: 0
      },
      companyTemplateList: [],
      companyPage: {
        page: 1,
        size: 10,
        total: 0
      }
    }
  },

  computed: {
    tabList() {
      if (this.isCompanyFirst) {
        return [
          { name: 'company', label: '企业模板' },
          { name: 'platform', label: '平台模板' }
        ]
      }
      return [
        { name: 'platform', label: '平台模板' },
        { name: 'company', label: '企业模板' }
      ]
    },

    tabObj() {
      return {
        platform: {
          total: this.platformPage.total,
          page: this.platformPage.page,
          size: this.platformPage.size,
          list: this.platformList
        },

        company: {
          total: this.companyPage.total,
          page: this.companyPage.page,
          size: this.companyPage.size,
          list: this.companyTemplateList
        }
      }
    }
  },

  watch: {
    noticeType: {
      handler: function(val) {
        this.filterForm = {
          templateName: this.filterForm.templateName || '',
          noticeType: this.noticeType || this.filterForm.noticeType
        }
      },
      immediate: true
    },

    isCompanyFirst: {
      handler: function(val) {
        if (val) {
          this.activeName = 'company'
        }
      },
      immediate: true
    }
  },

  methods: {
    /**
     * 打开弹窗
     */
    open() {
      this.drawerVisible = true
      this.handleTabClick()
    },

    /**
     * 关闭抽屉
     */
    handleDrawerClose() {
      this.drawerVisible = false
      this.selectionRow = []
    },

    /**
     * 选中模板
     */
    handleConfirm() {
      this.drawerVisible = false
      this.$emit('confirmed', this.selectRow?.templateNoticeId)
    },

    /**
     * 选中模板
     */
    select(row) {
      this.selectRow = row
    },

    /**
     * 切换tab页面
     */
    async handleTabClick() {
      if (this.activeName === 'platform') {
        const _data = await this.getList()
        this.platformList = _data.data?.records || []
        this.platformPage.total = _data.data?.total || 0
      } else {
        const _data = await this.getList()
        this.companyTemplateList = _data.data?.records || []
        this.companyPage.total = _data.data?.total || 0
      }
    },

    /**
     * 点击查询
     */
    search() {
      this.platformPage = {
        total: 0,
        page: 1,
        size: 10
      }
      this.companyPage = {
        total: 0,
        page: 1,
        size: 10
      }
      this.handleTabClick()
    },

    /**
     * 获取列表
     */
    async getList() {
      let page = 1
      let size = 10
      let isSystem = templateTypeDict.PLATFORM.value
      if (this.activeName === 'platform') {
        page = this.platformPage.page
        size = this.platformPage.size
        isSystem = templateTypeDict.PLATFORM.value
      } else {
        page = this.companyPage.page
        size = this.companyPage.size
        isSystem = templateTypeDict.COMPANY.value
      }
      try {
        const _data = await getTemplateNoticeListApi({
          ...this.filterForm,
          enabled: 1,
          purchaseType: this.purchaseType,
          isSystem,
          page,
          size
        })
        return _data || {}
      } catch (error) {
        this.$message.error(error.message)
      }
    }
  }
}
</script>
